<script>
    import { selectedGroup } from '../../store';
    import { Spinner, Table } from 'sveltestrap';
    import TableColumn from '../../components/TableColumn.svelte';   
    import http from '../../api/http.js';
    import Prettysize from 'prettysize';
    export let computerId;
    let logicalDrives = [];

    $: {
      computerId;
      loadLogicalDrives()
    }

    async function loadLogicalDrives(columnValue, sortTypeArg){
        let ascending = sortTypeArg == sortType.ascending ? true : false;
        if(columnValue == undefined){
            columnValue = 0;
        }

        if(ascending == undefined){
            ascending = true;
        }

        const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/logicaldrives/${computerId}/${$selectedGroup}/${columnValue}/${ascending}`);

        if(res.status == 200){
            logicalDrives = await res.json();
        }
        else{
            logicalDrives = [];
        }
    }

    let sortType = {
      ascending: 'ascending',
      descending: 'descending',
      resting: 'resting'
    }

    let activeColumn = {
    columnValue: 0,
    sortType: sortType.ascending,
  };

    function toggleSort(columnValue, theSortType){
        if(activeColumn.value != columnValue){
            activeColumn.columnValue = columnValue;
        }

        switch(theSortType){
        case sortType.resting:     
            activeColumn.sortType = sortType.ascending;  
            break;
        case sortType.ascending:
            activeColumn.sortType = sortType.descending;
            break;
        case sortType.descending:
            activeColumn.sortType = sortType.ascending;
            break;
        }        

        if(activeColumn.sortType != sortType.resting){
            loadLogicalDrives(columnValue, activeColumn.sortType);
        }
        else{
            activeColumn.columnValue = 0;
            activeColumn.sortType = sortType.ascending;
            loadLogicalDrives(0, activeColumn.sortType);
        }
    }

</script>

{#await loadLogicalDrives(activeColumn.columnValue, activeColumn.sortType)}
    <Spinner color="primary" type="border"></Spinner>
{:then}
    <Table responsive>
        <thead>     
            <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Device Id</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>Drive Type</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(2, activeColumn.sortType)} active={activeColumn.columnValue == 2} sortType={activeColumn.sortType}>Free Space</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(3, activeColumn.sortType)} active={activeColumn.columnValue == 3} sortType={activeColumn.sortType}>Size</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>Serial</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} active={activeColumn.columnValue == 5} sortType={activeColumn.sortType}>Volume Name</TableColumn>
        </thead>

        <tbody>
            {#if logicalDrives.length > 0}
                {#each logicalDrives as disk}
                    <tr id="software-row-{disk.id}">
                        <td>{disk.deviceId}</td>
                        <td>{disk.driveType}</td>
                        <td>{Prettysize(disk.freeSpace)}</td>
                        <td>{Prettysize(disk.size)}</td>
                        <td>{disk.serial}</td>
                        <td>{disk.volumeName}</td>
                    </tr>            
                {/each}
            {:else}
                <tr>
                    <td colspan="7" class="text-center">No Storage Devices Found</td>
                </tr>
            {/if}
        </tbody>
    </Table>
{/await}

<style>

</style>